/*
 * Olza Logistic's Pickup Points selector Widget
 *
 * @author    Marcin Orlowski <marcin.orlowski (#) develart (.) cz>
 * @copyright 2022-2025 DevelArt
 * @license   http://www.opensource.org/licenses/mit-license.php MIT
 * @link      https://bitbucket.org/develart/pp-widget/
 */

const OlzaLangTranslations = {
    // English
    "en": {
        "native-language-name": "English",
        "title": "Select pickup point",
        "search-input-placeholder": "Search for a pick up point",
        "search-result-not-found": "Not found",
        "details-show-on-map-button": "Show on map",
        "details-hide-details-button": "Hide details",
        "details-select-button": "Select",
        "open-hours": "Opening hours",
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday",
        "closest-point": "Closest pickup points",
        "nearby-no-points-in-radius": "No pickup points found in %s meters from selected location.",
        "nearby-no-points-matching-filters": "No pickup points found matching your filters.",
        "config-request-failed": "Failed to obtain runtime config from API.",
        "nearby-request-failed": "Failed to fetch nearby places.",
        "nearby-initial-message": "Click on map to have list of nearby Pickup Places updated.",
        // This is shown when talking to API failed.
        "find-request-failed": "Failed to obtain search results.",
        // This is shown when talking to API failed.
        "find-request-processing-failed": "Search failed: %s",
        "api-error-occurred": "API error occurred: %s",
        "closest-points-title": "Closest pickup points",
        "spedition-selector-all": "All",
        "details-download-failed": "Error loading details of selected location.",

        "open247": "This point is open 24/7",
        "cod-available": "Cash on Delivery supported",
        "payment-type-cash": "Cash payments available",
        "payment-type-card": "Card payments available",
        "payment-type-online": "Online payments available",

        "advanced-filters-group-label": "Advanced filters",

        "filter-pp-type-point": "Pickup points",
        "filter-pp-type-post": "Post offices",
        "filter-pp-type-locker": "Lockers",

        "no-valid-config-received-from-api": "No valid API config received. Please reload the widget.",
        "no-valid-speditions-found": "No valid spedition found. Please reload the widget.",
        "no-valid-api-response": "No valid API response received. Please reload the widget.",
        "no-valid-speditions-requested": "No valid spedition requested. Please reload the widget.",
    },
    // Poland (Polish / Polski)
    "pl": {
        "native-language-name": "Polski",
        "title": "Wybierz punkt odbioru",
        "search-input-placeholder": "Znajdź punkt odbioru",
        "search-result-not-found": "Nie znaleziono",
        "details-show-on-map-button": "Pokaż na mapie",
        "details-hide-details-button": "Ukryj szczegóły",
        "details-select-button": "Wybierz",
        "open-hours": "Godziny otwarcia",
        "monday": "Poniedziałek",
        "tuesday": "Wtorek",
        "wednesday": "Środa",
        "thursday": "Czwartek",
        "friday": "Piątek",
        "saturday": "Sobota",
        "sunday": "Niedziela",
        "closest-point": "Najbliższe punkty odbioru",
        "nearby-no-points-in-radius": "Nie znaleziono żadnych punktów w promieniu %s metrów od wybranej lokalizacji.",
        "nearby-no-points-matching-filters": "Nie znaleziono żadnych punktów pasujących do wybranych filtrów.",
        "config-request-failed": "Nie udało się uzyskać konfiguracji runtime z interfejsu API.",
        "nearby-request-failed": "Nie udało się wczytać pobliskich punktów.",
        "nearby-initial-message": "Kliknij na mapie aby zakutalizować listę pobliskich punktów.",
        "find-request-failed": "Nie udało się uzyskać wyników wyszukiwania.",
        "find-request-processing-failed": "Wyszukiwanie nie powiodło się: %s",
        "api-error-occurred": "Wystąpił błąd API: %s",
        "closest-points-title": "Najbliższe punkty odbioru",
        "spedition-selector-all": "Wszystkie",
        "details-download-failed": "Błąd pobierania danych wybranego punktu.",

        "open247": "Punkt otwarty całą dobę",
        "cod-available": "Płatność za pobraniem dostępna",
        "payment-type-cash": "Płatność gotówką dostępna",
        "payment-type-card": "Płatność kartą dostępna",
        "payment-type-online": "Płatność online dostępna",

        "advanced-filters-group-label": "Filtry zaawansowane",

        "filter-pp-type-point": "Punkty odbioru",
        "filter-pp-type-post": "Placówki pocztowe",
        "filter-pp-type-locker": "Paczkomaty",

        "no-valid-config-received-from-api": "Nie otrzymano poprawnej konfiguracji API. Proszę przeładuj widżet.",
        "no-valid-speditions-found": "Nie znaleziono poprawnej spedycji. Proszę przeładuj widżet.",
        "no-valid-api-response": "Nie otrzymano poprawnej odpowiedzi API. Proszę przeładuj widżet.",
        "no-valid-speditions-requested": "Nie otrzymano poprawnej spedycji. Proszę przeładuj widżet.",
    },
    // Czechia (Czech / Česky)
    "cs": {
        "native-language-name": "Česky",
        "title": "Vyberte výdejní místo",
        "search-input-placeholder": "Hledat výdejní místo",
        "search-result-not-found": "Nenalezeno",
        "details-show-on-map-button": "Zobrazit na mapě",
        "details-hide-details-button": "Skrýt podrobnosti",
        "details-select-button": "Vybrat",
        "open-hours": "Otevírací doba",
        "monday": "Pondělí",
        "tuesday": "Úterý",
        "wednesday": "Středa",
        "thursday": "Čtvrtek",
        "friday": "Pátek",
        "saturday": "Sobota",
        "sunday": "Neděle",
        "closest-point": "Nejbližší výdejní místa",
        "nearby-no-points-in-radius": " V okruhu %s metrů od vybrané polohy nebyla nalezena žádná výdejní místa.",
        "nearby-no-points-matching-filters": "Nebyla nalezena žádná výdejní místa odpovídající vybraným filtrům.",
        "config-request-failed": "Nepodařilo se získat konfiguraci runtime z rozhraní API.",
        "nearby-request-failed": "Nepodařilo se načíst okolní místa.",
        "nearby-initial-message": "Klikněte na mapu pro aktualizaci seznamu okolních výdejních míst.",
        "find-request-failed": "Nepodařilo se získat výsledky vyhledávání.",
        "find-request-processing-failed": "Vyhledávání se nezdařilo: %s",
        "api-error-occurred": "Došlo k chybě API: %s",
        "closest-points-title": "Nejbližší výdejní místa",
        "spedition-selector-all": "Všechno",
        "details-download-failed": "Chyba při načítání podrobností o vybraném místě.",

        "open247": "Toto výdejní místo je otevřeno nonstop",
        "cod-available": "Platba na dobírku je podporována",
        "payment-type-cash": "Možnost platby v hotovosti",
        "payment-type-card": "Možnost platby kartou",
        "payment-type-online": "Možnost platby online",

        "advanced-filters-group-label": "Pokročilé filtry",

        "filter-pp-type-point": "Výdejní místa",
        "filter-pp-type-post": "Pošty",
        "filter-pp-type-locker": "Výdejní boxy",

        "no-valid-config-received-from-api": "Nepodařilo se získat platnou konfiguraci API. Obnovte prosím widget.",
        "no-valid-speditions-found": "Nebyla nalezena žádná platná expedice. Obnovte prosím widget.",
        "no-valid-api-response": "Nepodařilo se získat platnou odpověď API. Obnovte prosím widget.",
        "no-valid-speditions-requested": "Nebyla nalezena žádná platná expedice. Obnovte prosím widget.",
    },
    // Hungary (Hungarian / Magyar)
    "hu": {
        "native-language-name": "Magyar",
        "title": "Felvételi pont kiválasztása",
        "search-input-placeholder": "Felvételi pont keresése",
        "search-result-not-found": "Nincs találat",
        "details-show-on-map-button": "Megjelenítés térképen",
        "details-hide-details-button": "Részletek elrejtése",
        "details-select-button": "Kiválasztás",
        "open-hours": "Nyitvatartási idő",
        "monday": "Hétfő",
        "tuesday": "Kedd",
        "wednesday": "Szerda",
        "thursday": "Csütörtök",
        "friday": "Péntek",
        "saturday": "Szombat",
        "sunday": "Vasárnap",
        "closest-point": "Legközelebbi felvételi pontok",
        "nearby-no-points-in-radius": " A kiválasztott hely %s-méteres körzetében nem található átvételi pont.",
        "nearby-no-points-matching-filters": "Nem található átvételi pont a kiválasztott szűrőknek megfelelően.",
        "config-request-failed": "Nem sikerült lekérni a runtime konfigurációt az API-ból.",
        "nearby-request-failed": "Nem sikerült letölteni közeli helyeket.",
        "nearby-initial-message": "Kattintson a térképre a közeli felvételi pontok listájának frissítéséhez.",
        "find-request-failed": "Nem sikerült lekérni a keresési eredményeket.",
        "find-request-processing-failed": "A keresés nem sikerült: %s",
        "api-error-occurred": "API-hiba történt: %s",
        "closest-points-title": "Legközelebbi felvételi pontok",
        "spedition-selector-all": "Minden",
        "details-download-failed": "Hiba történt a kiválasztott hely adatainak betöltésekor.",

        "open247": "Ez a pont a nap 24 órájában nyitva",
        "cod-available": "Van lehetőség utánvétes fizetésre",
        "payment-type-cash": "Van lehetőség készpénzes fizetésre",
        "payment-type-card": "Van lehetőség kártyás fizetésre",
        "payment-type-online": "Van lehetőség online fizetésre",

        "advanced-filters-group-label": "Haladó szűrők",

        "filter-pp-type-point": "Felvételi pontok",
        "filter-pp-type-post": "Posták",
        "filter-pp-type-locker": "Csomagfelvételi pontok",

        "no-valid-config-received-from-api": "Nem sikerült érvényes API konfigurációt kapni. Kérjük, frissítse a widgetet.",
        "no-valid-speditions-found": "Nem található érvényes szállítás. Kérjük, frissítse a widgetet.",
        "no-valid-api-response": "Nem érkezett érvényes API válasz. Kérjük, frissítse a widgetet.",
        "no-valid-speditions-requested": "Nem található érvényes szállítás. Kérjük, frissítse a widgetet.",
    },
    // Slovakia (Slovak / Slovenčina)
    "sk": {
        "native-language-name": "Slovenčina",
        "title": "Vyberte miesto vyzdvihnutia",
        "search-input-placeholder": "Vyhľadať miesto vyzdvihnutia",
        "search-result-not-found": "Nenájdené",
        "details-show-on-map-button": "Ukázať na mape",
        "details-hide-details-button": "Skryť podrobnosti",
        "details-select-button": "Vyberte",
        "open-hours": "Otváracie hodiny",
        "monday": "Pondelok",
        "tuesday": "Utorok",
        "wednesday": "Streda",
        "thursday": "Štvrtok",
        "friday": "Piatok",
        "saturday": "Sobota",
        "sunday": "Nedeľa",
        "closest-point": "Najbližšie miesta vyzdvihnutia",
        "nearby-no-points-in-radius": "V okruhu %s metrov od vybranej lokality sa nenašli žiadne miesta vyzdvihnutia.",
        "nearby-no-points-matching-filters": "Nenašli sa žiadne miesta vyzdvihnutia, ktoré by zodpovedali zadaným kritériám.",
        "config-request-failed": "Nepodarilo sa získať konfiguráciu runtime z API.",
        "nearby-request-failed": "Nepodarilo sa načítať miesta v okolí.",
        "nearby-initial-message": "Kliknite na mapu pre aktualizáciu zoznamu najbližších miest vyzdvihnutia.",
        "find-request-failed": "Nepodarilo sa získať výsledky vyhľadávania.",
        "find-request-processing-failed": "Vyhľadávanie zlyhalo: %s",
        "api-error-occurred": "Vyskytla sa chyba API: %s",
        "closest-points-title": "Najbližšie miesta vyzdvihnutia",
        "spedition-selector-all": "Všetky",
        "details-download-failed": "Chyba pri načítavaní podrobností vybratého miesta.",

        "open247": "Toto miesto je otvorené 24/7",
        "cod-available": "Dobierka možná",
        "payment-type-cash": "Platba v hotovosti možná",
        "payment-type-card": "Platba kartou možná",
        "payment-type-online": "Platba online možná",

        "advanced-filters-group-label": "Pokročilé filtre",

        "filter-pp-type-point": "Miesta vyzdvihnutia",
        "filter-pp-type-post": "Pošty",
        "filter-pp-type-locker": "Samoobslužné výdajné boxy",

        "no-valid-config-received-from-api": "Nepodarilo sa získať platnú konfiguráciu API. Obnovte prosím widget.",
        "no-valid-speditions-found": "Nenašla sa žiadna platná expedícia. Obnovte prosím widget.",
        "no-valid-api-response": "Nepodarilo sa získať platnú odpoveď API. Obnovte prosím widget.",
        "no-valid-speditions-requested": "Nenašla sa žiadna platná expedícia. Obnovte prosím widget.",
    },
    // Romania (Romanian / Română)
    "ro": {
        "native-language-name": "Română",
        "title": "Selectați un punct de preluare",
        "search-input-placeholder": "Căutați un punct de preluare",

        "details-show-on-map-button": "Arată pe hartă",
        "details-hide-details-button": "Ascunde detaliile",
        "details-select-button": "Selectare",
        "open-hours": "Orar de funcționare",
        "monday": "Luni",
        "tuesday": "Marți",
        "wednesday": "Miercuri",
        "thursday": "Joi",
        "friday": "Vineri",
        "saturday": "Sâmbătă",
        "sunday": "Duminică",
        "closest-point": "Cele mai apropiate puncte de preluare",
        "nearby-no-points-in-radius": "Nu s-au găsit puncte de preluare la mai puțin de %s de metri de locația selectată.",
        "nearby-no-points-matching-filters": "Nu s-au găsit puncte de preluare care să corespundă criteriilor selectate.",
        "config-request-failed": "Nu s-a putut obține configurarea de execuție din API.",
        "nearby-request-failed": "Nu au putut fi returnate rezultatele cu locurile din apropiere.",
        "nearby-initial-message": "Faceți clic pe hartă pentru a actualiza lista cu cele mai apropiate puncte de preluare.",
        "find-request-failed": "Nu s-au putut obține rezultatele căutării.",
        "find-request-processing-failed": "Căutare eșuată: %s",
        "api-error-occurred": "Eroare API: %s",
        "closest-points-title": "Cele mai apropiate puncte de preluare",
        "spedition-selector-all": "Toate",
        "details-download-failed": "Eroare la încărcarea detaliilor locației selectate.",

        "open247": "Acest punct este deschis non-stop",
        "cod-available": "Posibilitate de plată la livrare",
        "payment-type-cash": "Posibilitate de plată cu numerar",
        "payment-type-card": "Posibilitate de plată cu card",
        "payment-type-online": "Posibilitate de plată online",

        "advanced-filters-group-label": "Filtre avansate",

        "filter-pp-type-point": "Puncte de preluare",
        "filter-pp-type-post": "Oficii poștale",
        "filter-pp-type-locker": "Cutii poștale digitale",

        "no-valid-config-received-from-api": "Nu s-a primit nicio configurație validă de la API. Vă rugăm să reîncărcați widget-ul.",
        "no-valid-speditions-found": "Nu s-a găsit nicio expediție validă. Vă rugăm să reîncărcați widget-ul.",
        "no-valid-api-response": "Nu s-a primit nicio răspuns API valid. Vă rugăm să reîncărcați widget-ul.",
        "no-valid-speditions-requested": "Nu s-a cerut nicio expediție validă. Vă rugăm să reîncărcați widget-ul.",
    },
    // Bulgaria (Bulgarian / Български)
    "bg": {
        "native-language-name": "Български",
        "title": "Избери място за взимане",
        "search-input-placeholder": "Търси място за взимане",
        "search-result-not-found": "Не е намерено",
        "details-show-on-map-button": "Покажи на картата",
        "details-hide-details-button": "Скрий подробностите",
        "details-select-button": "Избери",
        "open-hours": "Работно време",
        "monday": "Понеделник",
        "tuesday": "Вторник",
        "wednesday": "Сряда",
        "thursday": "Четвъртък",
        "friday": "Петък",
        "saturday": "Събота",
        "sunday": "Неделя",
        "closest-point": "Най-близки места за взимане",
        "nearby-no-points-in-radius": "Не са открити места за взимане в рамките на %s метра от избраното местоположение.",
        "nearby-no-points-matching-filters": "Не са открити места за взимане, отговарящи на избраните критерии.",
        "config-request-failed": "Неуспешно получаване на runtime config от API.",
        "nearby-request-failed": "Неуспешно извличане на места наблизо.",
        "nearby-initial-message": "Кликнете върху картата, за да актуализирате списъка с най-близките места за взимане.",
        "find-request-failed": "Неуспешно получаване на резултати от търсене.",
        "find-request-processing-failed": "Неуспешно търсене: %s",
        "api-error-occurred": "Грешка в API: %s",
        "closest-points-title": "Най-близки места за взимане",
        "spedition-selector-all": "Всичко",
        "details-download-failed": "Грешка при зареждането на подробностите за избраното местоположение.",

        "open247": "Този пункт е отворен денонощно",
        "cod-available": "Възможност за наложен платеж",
        "payment-type-cash": "Възможност за плащане в брой",
        "payment-type-card": "Възможност за плащане с карта",
        "payment-type-online": "Възможност за онлайн плащане",

        "advanced-filters-group-label": "Разширени филтри",

        "filter-pp-type-point": "Места за взимане",
        "filter-pp-type-post": "Пощенски станции",
        "filter-pp-type-locker": "Автоматични пощенски станции",

        "no-valid-config-received-from-api": "Не е получена валидна конфигурация от API. Моля презаредете виджета.",
        "no-valid-speditions-found": "Не е намерена валидна експедиция. Моля презаредете виджета.",
        "no-valid-api-response": "Не е получен валиден отговор от API. Моля презаредете виджета.",
        "no-valid-speditions-requested": "Не е заявена валидна експедиция. Моля презаредете виджета.",
    },
    // Greece (Greek / Ελληνικά)
    "el": {
        "native-language-name": "Ελληνικά",
        "title": "Επιλέξτε σημείο παραλαβής",
        "search-input-placeholder": "Αναζητήστε ένα σημείο παραλαβής",
        "search-result-not-found": "Δεν βρέθηκε",
        "details-show-on-map-button": "Δείξτε στον χάρτη",
        "details-hide-details-button": "Λιγότερες λεπτομέρειες",
        "details-select-button": "Επιλέξτε",
        "open-hours": "Ώρες λειτουργίας",
        "monday": "Δευτέρα",
        "tuesday": "Τρίτη",
        "wednesday": "Τετάρτη",
        "thursday": "Πέμπτη",
        "friday": "Παρασκευή",
        "saturday": "Σάββατο",
        "sunday": "Κυριακή",
        "closest-point": "Πλησιέστερα σημεία παραλαβής",
        "nearby-no-points-in-radius": "Δεν βρέθηκαν σημεία παραλαβής εντός %s μέτρων από την επιλεγμένη τοποθεσία.",
        "nearby-no-points-matching-filters": "Δεν βρέθηκαν σημεία παραλαβής που να ταιριάζουν με τα επιλεγμένα φίλτρα.",
        "config-request-failed": "Aπέτυχε να λάβει τη ρύθμιση χρόνου εκτέλεσης από το API.",
        "nearby-request-failed": "Aπέτυχε να λάβει κοντινά μέρη.",
        "nearby-initial-message": "Κάντε κλικ στον χάρτη για να ενημερώσετε τη λίστα με τα κοντινότερα σημεία παραλαβής.",
        "find-request-failed": "Aπέτυχε να λάβει αποτελέσματα αναζήτησης.",
        "find-request-processing-failed": "H αναζήτηση απέτυχε: %s",
        "api-error-occurred": "Παρουσιάστηκε σφάλμα API: %s",
        "closest-points-title": "Πλησιέστερα σημεία παραλαβής",
        "spedition-selector-all": "Ολα",
        "details-download-failed": "Σφάλμα κατά τη φόρτωση των λεπτομερειών της επιλεγμένης τοποθεσίας.",

        "open247": "Αυτό το σημείο είναι ανοιχτό 24/7",
        "cod-available": "Δυνατότητα πληρωμής με αντικαταβολή",
        "payment-type-cash": "Δυνατότητα πληρωμής με μετρητά",
        "payment-type-card": "Δυνατότητα πληρωμής με κάρτα",
        "payment-type-online": "Online payments available",

        "advanced-filters-group-label": "Προχωρημένα φίλτρα",

        "filter-pp-type-point": "Σημεία παραλαβής",
        "filter-pp-type-post": "Ταχυδρομικά γραφεία",
        "filter-pp-type-locker": "Θυρίδες",

        "no-valid-config-received-from-api": "Δεν λάβαμε έ γκυρη ρύθμιση από το API. Παρακαλούμε ανανεώστε το widget.",
        "no-valid-speditions-found": "Δεν βρέθηκε έγκυρη εκστρατεία. Παρακαλούμε ανανεώστε το widget.",
        "no-valid-api-response": "Δεν λάβαμε έγκυρη απάντηση από το API. Παρακαλούμε ανανεώστε το widget.",
        "no-valid-speditions-requested": "Δεν ζητήθηκε έγκυρη εκστρατεία. Παρακαλούμε ανανεώστε το widget.",
    },
    // Lithuania (Lithuanian / Lietuvių)
    "lt": {
        "native-language-name": "Lietuvių",
        "title": "Pasirinkti paėmimo vietą",
        "search-input-placeholder": "Ieškoti paėmimo vietos",
        "search-result-not-found": "Nerasta",
        "details-show-on-map-button": "Rodyti žemėlapyje",
        "details-hide-details-button": "Slėpti išsamią informaciją",
        "details-select-button": "Pasirinkti",
        "open-hours": "Darbo laikas",
        "monday": "Pirmadienis",
        "tuesday": "Antradienis",
        "wednesday": "Trečiadienis",
        "thursday": "Ketvirtadienis",
        "friday": "Penktadienis",
        "saturday": "Šeštadienis",
        "sunday": "Sekmadienis",
        "closest-point": "Artimiausios paėmimo vietos",
        "nearby-no-points-in-radius": "Nerasta paėmimo vietų %s metrų atstumu nuo pasirinktos vietos.",
        "nearby-no-points-matching-filters": "Nerasta paėmimo vietų, atitinkančių pasirinktas filtrus.",
        "config-request-failed": "Nepavyko gauti vykdymo laiko konfigūracijos iš API.",
        "nearby-request-failed": "Nepavyko gauti netoliese esančių vietų.",
        "nearby-initial-message": "Spustelėkite žemėlapį, kad atnaujintumėte artimiausių paėmimo vietų sąrašą.",
        "find-request-failed": "Nepavyko gauti paieškos rezultatų.",
        "find-request-processing-failed": "Paieška nepavyko: %s",
        "api-error-occurred": "Įvyko API klaida: %s",
        "closest-points-title": "Artimiausios paėmimo vietos",
        "spedition-selector-all": "Visi",
        "details-download-failed": "Įkeliant išsamią pasirinktos vietos informaciją įvyko klaida.",

        "open247": "Šis punktas veikia visą parą",
        "cod-available": "Palaikomas mokėjimas pristatymo metu",
        "payment-type-cash": "Galimas mokėjimas grynaisiais",
        "payment-type-card": "Galimas mokėjimas kortele",
        "payment-type-online": "Online payments available",

        "advanced-filters-group-label": "Išplėstiniai filtrai",

        "filter-pp-type-point": "Pasiėmimo vietos",
        "filter-pp-type-post": "Pašto skyriai",
        "filter-pp-type-locker": "Pasiėmimo terminalai",

        "no-valid-config-received-from-api": "Nepavyko gauti galiojančios API konfigūracijos. Prašome atnaujinti valdiklį.",
        "no-valid-speditions-found": "Nerasta jokių galiojančių ekspedicijų. Prašome atnaujinti valdiklį.",
        "no-valid-api-response": "Nepavyko gauti galiojančio API atsakymo. Prašome atnaujinti valdiklį.",
        "no-valid-speditions-requested": "Nerasta jokių galiojančių ekspedicijų. Prašome atnaujinti valdiklį.",
    },
    // Latvia (Latvian / Latviešu)
    "lv": {
        "native-language-name": "Latviešu",
        "title": "Izvēlieties saņemšanas vietu",
        "search-input-placeholder": "Meklēt saņemšanas vietu",

        "details-show-on-map-button": "Rādīt kartē",
        "details-hide-details-button": "Slēpt detalizētu informāciju",
        "details-select-button": "Izvēlēties",
        "open-hours": "Darba laiks",
        "monday": "Pirmdiena",
        "tuesday": "Otrdiena",
        "wednesday": "Trešdiena",
        "thursday": "Ceturtdiena",
        "friday": "Piektdiena",
        "saturday": "Sestdiena",
        "sunday": "Svētdiena",
        "closest-point": "Tuvākās saņemšanas vietas",
        "nearby-no-points-in-radius": "%s metru attālumā no izvēlētās vietas nav atrasta neviena saņemšanas vieta.",
        "nearby-no-points-matching-filters": "Neviena saņemšanas vieta neatbilst izvēlētajiem filtriem.",
        "config-request-failed": "Neizdevās iegūt izpildlaika konfigurāciju no API.",
        "nearby-request-failed": "Neizdevās ielādēt saņemšanas vietas tuvumā.",
        "nearby-initial-message": "Noklikšķiniet uz kartes, lai atjaunotu tuvākās saņemšanas vietas sarakstu.",
        "find-request-failed": "Neizdevās ielādēt meklēšanas rezultātus.",
        "find-request-processing-failed": "Meklēšana neizdevās: %s",
        "api-error-occurred": "Radās API kļūda: %s",
        "closest-points-title": "Tuvākās saņemšanas vietas",
        "spedition-selector-all": "Visi",
        "details-download-failed": "Ielādējot atlasītās atrašanās vietas informāciju, radās kļūda.",

        "open247": "Šis punkts ir atvērts visu diennakti",
        "cod-available": "Pieejama piegāde ar samaksu skaidrā naudā",
        "payment-type-cash": "Iespējama samaksa skaidrā naudā",
        "payment-type-card": "Iespējama samaksa ar karti",
        "payment-type-online": "Online payments available",

        "advanced-filters-group-label": "Izvērstie filtri",

        "filter-pp-type-point": "Saņemšanas vietas",
        "filter-pp-type-post": "Pasta nodaļas",
        "filter-pp-type-locker": "Pakomāti",

        "no-valid-config-received-from-api": "Nav saņemta derīga API konfigurācija. Lūdzu, atsvaidziniet logrīku.",
        "no-valid-speditions-found": "Nav atrasta neviena derīga ekspedīcija. Lūdzu, atsvaidziniet logrīku.",
        "no-valid-api-response": "Nav saņemts neviens derīgs API atbildes. Lūdzu, atsvaidziniet logrīku.",
        "no-valid-speditions-requested": "Nav pieprasīta neviena derīga ekspedīcija. Lūdzu, atsvaidziniet logrīku.",
    },
    // Estonia (Estonian / Eeesti)
    "et": {
        "native-language-name": "Eeesti",
        "search-input-placeholder": "Otsi pealevõtmiskohta",
        "search-result-not-found": "Ei leitud",
        "details-show-on-map-button": "Kuva kaardil",
        "details-hide-details-button": "Peida üksikasjad",
        "details-select-button": "Vali",
        "open-hours": "Avatud",
        "monday": "Esmaspäev",
        "tuesday": "Teisipäev",
        "wednesday": "Kolmapäev",
        "thursday": "Neljapäev",
        "friday": "Reede",
        "saturday": "Laupäev",
        "sunday": "Pühapäev",
        "closest-point": "Lähimad pealevõtmiskohad",
        "nearby-no-points-in-radius": "Teie valitud asukohale ei leitud ühtegi pealevõtmispunkti %s meetri raadiuses.",
        "nearby-no-points-matching-filter": "Teie valitud filtritele ei vasta ühtegi pealevõtmispunkti.",
        "config-request-failed": "API käitusaja seadistuse hankimine nurjus.",
        "nearby-request-failed": "Lähimate kohtade hankimine nurjus.",
        "nearby-initial-message": "Värskenda lähimate pealevõtmiskohtade nimekirja klõpsates kaardil.",
        "find-request-failed": "Otsingutulemuste hankimine nurjus.",
        "find-request-processing-failed": "Otsing nurjus: %s",
        "api-error-occurred": "Ilmnes API viga: %s",
        "closest-points-title": "Lähimad pealevõtmiskohad",
        "spedition-selector-all": "Kõik",
        "details-download-failed": "Viga valitud asukoha üksikasjade laadimisel.",

        "open247": "See punkt on avatud ööpäevaringselt",
        "cod-available": "Võimalik tasuta kättetoimetamisel",
        "payment-type-cash": "Saadaval on sularahamaksed",
        "payment-type-card": "Saadaval on kaardimaksed",
        "payment-type-online": "Online payments available",

        "advanced-filters-group-label": 'Täiustatud filtrid',

        "filter-pp-type-point": "Pealevõtmiskoht",
        "filter-pp-type-post": "Postkontor",
        "filter-pp-type-locker": "Hoiukapp",

        "no-valid-config-received-from-api": "API-st ei saadud kehtivat konfiguratsiooni. Palun värskendage vidinat.",
        "no-valid-speditions-found": "Kehtivaid ekspeditsioone ei leitud. Palun värskendage vidinat.",
        "no-valid-api-response": "Kehtivat API vastust ei saadud. Palun värskendage vidinat.",
        "no-valid-speditions-requested": "Kehtivaid ekspeditsioone ei küsitud. Palun värskendage vidinat.",
    },
    // Ukraine (Ukrainian / Українська)
    "ua": {
        "native-language-name": "Українська",
        "title": "Виберіть пункт видачі",
        "search-input-placeholder": "Пошук пункту видачі",
        "search-result-not-found": "Не знайдено",
        "details-show-on-map-button": "Показати на мапі",
        "details-hide-details-button": "Сховати деталі",
        "details-select-button": "Вибрати",
        "open-hours": "Години роботи",
        "monday": "Понеділок",
        "tuesday": "Вівторок",
        "wednesday": "Середа",
        "thursday": "Четвер",
        "friday": "П'ятниця",
        "saturday": "Субота",
        "sunday": "Неділя",
        "closest-point": "Найближчі пункти видачі",
        "nearby-no-points-in-radius": "Не знайдено пунктів видачі у радіусі %s метрів від обраного місцезнаходження.",
        "nearby-no-points-matching-filters": "Не знайдено пунктів видачі, що відповідають вашим фільтрам.",
        "config-request-failed": "Не вдалося отримати конфігурацію виконання від API.",
        "nearby-request-failed": "Не вдалося отримати дані про найближчі місця.",
        "nearby-initial-message": "Клацніть на мапі, щоб оновити список найближчих пунктів видачі.",
        "find-request-failed": "Не вдалося отримати результати пошуку.",
        "find-request-processing-failed": "Пошук не вдався: %s",
        "api-error-occurred": "Сталася помилка API: %s",
        "closest-points-title": "Найближчі пункти видачі",
        "spedition-selector-all": "Всі",
        "details-download-failed": "Помилка завантаження деталей обраного місця.",

        "open247": "Ця точка працює цілодобово",
        "cod-available": "Доступна оплата при доставці",
        "payment-type-cash": "Доступна готівкова оплата",
        "payment-type-card": "Доступна оплата карткою",
        "payment-type-online": "Доступна онлайн-оплата",

        "advanced-filters-group-label": "Розширені фільтри",

        "filter-pp-type-point": "Пункти видачі",
        "filter-pp-type-post": "Поштові відділення",
        "filter-pp-type-locker": "Поштові скриньки",

        "no-valid-config-received-from-api": "Не вдалося отримати дійсну конфігурацію від API. Будь ласка, оновіть віджет.",
        "no-valid-speditions-found": "Не знайдено жодної дійсної експедиції. Будь ласка, оновіть віджет.",
        "no-valid-api-response": "Не отримано жодної дійсної відповіді API. Будь ласка, оновіть віджет.",
        "no-valid-speditions-requested": "Не було запитано жодної дійсної експедиції. Будь ласка, оновіть віджет.",
    },
    // Russia (Russian / Русский)
    "ru": {
        "native-language-name": "Русский",
        "title": "Выберите пункт выдачи",
        "search-input-placeholder": "Поиск пункта выдачи",
        "search-result-not-found": "Не найдено",
        "details-show-on-map-button": "Показать на карте",
        "details-hide-details-button": "Скрыть детали",
        "details-select-button": "Выбрать",
        "open-hours": "Часы работы",
        "monday": "Понедельник",
        "tuesday": "Вторник",
        "wednesday": "Среда",
        "thursday": "Четверг",
        "friday": "Пятница",
        "saturday": "Суббота",
        "sunday": "Воскресенье",
        "closest-point": "Ближайшие пункты выдачи",
        "nearby-no-points-in-radius": "Не найдено пунктов выдачи в радиусе %s метров от выбранного местоположения.",
        "nearby-no-points-matching-filters": "Не найдено пунктов выдачи, соответствующих вашим фильтрам.",
        "config-request-failed": "Не удалось получить конфигурацию выполнения от API.",
        "nearby-request-failed": "Не удалось получить данные о ближайших местах.",
        "nearby-initial-message": "Кликните на карте, чтобы обновить список ближайших пунктов выдачи.",
        "find-request-failed": "Не удалось получить результаты поиска.",
        "find-request-processing-failed": "Поиск не удался: %s",
        "api-error-occurred": "Произошла ошибка API: %s",
        "closest-points-title": "Ближайшие пункты выдачи",
        "spedition-selector-all": "Все",
        "details-download-failed": "Ошибка загрузки деталей выбранного места.",

        "open247": "Этот пункт работает круглосуточно",
        "cod-available": "Доступна оплата при получении",
        "payment-type-cash": "Доступна оплата наличными",
        "payment-type-card": "Доступна оплата картой",
        "payment-type-online": "Доступна онлайн-оплата",

        "advanced-filters-group-label": "Расширенные фильтры",

        "filter-pp-type-point": "Пункты выдачи",
        "filter-pp-type-post": "Почтовые отделения",
        "filter-pp-type-locker": "Почтовые ячейки",

        "no-valid-config-received-from-api": "Не удалось получить действительную конфигурацию от API. Пожалуйста, обновите виджет.",
        "no-valid-speditions-found": "Не найдено ни одной действительной экспедиции. Пожалуйста, обновите виджет.",
        "no-valid-api-response": "Не получен ни один действительный ответ API. Пожалуйста, обновите виджет.",
        "no-valid-speditions-requested": "Не было запрошено ни одной действительной экспедиции. Пожалуйста, обновите виджет.",
    },
};

/** ********************************************************************************************* **/

export default OlzaLangTranslations
